import lf from 'lovefield'

export function simu_eleves (schemaBuilder) {
  schemaBuilder.createTable('simu_eleves')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('code', lf.Type.STRING)
      .addColumn('password', lf.Type.STRING)
      .addColumn('mail', lf.Type.STRING)

      .addPrimaryKey(['id'])
      // .addUnique('code', ['code'])
}

/*
CREATE TABLE IF NOT EXISTS `simu-eleves` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `nom` varchar(50) NOT NULL,
  `code` varchar(16) NOT NULL,
  `password` varchar(10) NOT NULL,
  `mail` varchar(50) NOT NULL,
  PRIMARY KEY (`id`),
  UNIQUE KEY `code` (`code`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 AUTO_INCREMENT=1 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuEleves.schema.js